document.addEventListener("DOMContentLoaded", function () {
    let firstDisclosure = document.querySelector('.facets .disclosure-has-popup');
    let facet_heading = document.querySelector('.facets__heading');
    let custom_filter = document.querySelector('.cxtm_filters');

    facet_heading.addEventListener('click', function (event) {
        event.stopPropagation();  
        if (custom_filter.style.display === "block") {
            custom_filter.style.display = 'none';
        } else {
            custom_filter.style.display = "block";
            
          const urlParams = new URLSearchParams(window.location.search);
          const sortBy = urlParams.get("sort_by");
        
          if (sortBy === "price-descending" || sortBy === "price-ascending") {
            custom_filter.style.width = "70%";
           
          }
        }
    });

 
    document.addEventListener('click', function (event) {
        if (!facet_heading.contains(event.target) && !custom_filter.contains(event.target)) {
            custom_filter.style.display = 'none';
        }
    });


});


      document.querySelectorAll('.mobile-facets__main details').forEach(detail => {
    detail.addEventListener('click', function () {
        document.querySelectorAll('.mobile-facets__main details').forEach(otherDetail => {
            if (otherDetail !== this) {
                otherDetail.removeAttribute('open');
            }
        });
    });
});
 
 

    document.querySelectorAll('.cxtm_filters details').forEach(detail => {
    detail.addEventListener('click', function () {
        document.querySelectorAll('.cxtm_filters details').forEach(otherDetail => {
            if (otherDetail !== this) {
                otherDetail.removeAttribute('open');
            }
        });
    });
});


document.addEventListener("DOMContentLoaded", function () {
    function updateFacetHeading() {
        const hasActiveFilter = document.querySelector(".facet-checkbox.active") !== null;
        const heading = document.querySelector(".facets__heading");
        const summaryLabels = document.querySelectorAll(".facets__summary-label");
        const summaryLabels_mobile = document.querySelectorAll(".facets__summary-label-mobile")
        const existingDotHeading = document.querySelector(".green-dot.heading-dot");
 
        // Update heading dot
        if (hasActiveFilter && heading && !existingDotHeading) {
            const dot = document.createElement("span");
            dot.classList.add("green-dot", "heading-dot");
            dot.style.cssText = "display: inline-block; width: 4px; height: 4px; background: #8a89c6; border-radius: 50%; margin-left: 4px;";
            heading.insertAdjacentElement("afterend", dot);
        } else if (!hasActiveFilter && existingDotHeading) {
            existingDotHeading.remove();
        }
 
 
        summaryLabels.forEach(summaryLabel => {
            const detailsElement = summaryLabel.closest("details");
            const hasActiveCheckbox = detailsElement && detailsElement.querySelector(".facet-checkbox.active");
            const existingDot = summaryLabel.parentElement.querySelector(".green-dot.summary-dot");
 
            if (hasActiveCheckbox && !existingDot) {
                const dot = document.createElement("span");
                dot.classList.add("green-dot", "summary-dot");
                dot.style.cssText = "display: inline-block; width: 6px; height: 6px; background: #8a89c6; border-radius: 50%; margin-left: 3px; margin-bottom:3px;";
                summaryLabel.insertAdjacentElement("afterend", dot);
            } else if (!hasActiveCheckbox && existingDot) {
                existingDot.remove();
            }
        });
 
document.querySelectorAll('.mobile-facets__submenu').forEach(submenu => {
    const activeLabel = submenu.querySelector('.mobile-facets__label.active');
    const summary = submenu.closest('details')?.querySelector('.mobile-facets__summary');
    const existingDot = summary?.querySelector('.green-dot.summary-dot');
 
    if (activeLabel && summary && !existingDot) {
        const dot = document.createElement("span");
        dot.classList.add("green-dot", "summary-dot");
        dot.style.cssText = "display: inline-block; width: 6px; height: 6px; background: #8a89c6; border-radius: 50%; margin-left: 5px; margin-bottom:3px;";
        summary.querySelector('.facets__summary-label-mobile').insertAdjacentElement("afterend", dot);
    } else if (!activeLabel && existingDot) {
        existingDot.remove();
    }
}); 

       const facetRemove = document.querySelectorAll("facet-remove");
      facetRemove.forEach((item)=>{
            item.style.display = hasActiveFilter ? "block" : "none";
      })
        
       const applyButton = document.querySelectorAll('.apply-button');
applyButton.forEach((btn)=>{
   btn.disabled = !hasActiveFilter;
  btn.classList.toggle("disabled", !hasActiveFilter);
})
    }
 

    updateFacetHeading();
 
 
    const filterContainer = document.querySelector(".cxtm_filters");
    if (filterContainer) {
        const observer = new MutationObserver(updateFacetHeading);
        observer.observe(filterContainer, { childList: true, subtree: true });
    }
});
 
// here i write a code for check and chek 

function main_container_facets_check_uncheck (){}
  function facets_check_uncheck() {
  
    document.querySelectorAll('.facets__label').forEach(facet => {
      facet.addEventListener('click', function() {
        let custom_filter = document.querySelector('.cxtm_filters');
        setTimeout(() => {
          custom_filter.style.display = 'none';
        }, 2000);
      });
    });
  }

  facets_check_uncheck();

